<div class="p-grid">
    <div class="p-col-12 p-md-12">
        <div class="card">
			<h3>Experiências</h3>
			<h5>{{usuario.nome}} ({{usuario.matricula}})</h5>
			<div class="ui-g-12 ui-md-10">
			<p-table
				#dt
				[style]="{ 'margin-top': '2em'}"
				[value]="listaSolicitacoes"
				[responsive]="true"
				[globalFilterFields]="[
					'tituloAtendimento',
					'numeroAtendimento',
					'dataAtendimento'
				]"
			>
			<ng-template pTemplate="caption">
				<div style="text-align: right;">
				  <i class="pi pi-search" style="margin: 4px 4px 0 0;"></i>
				  <input
					type="text"
					pInputText
					placeholder="Procurar"
					(input)="dt.filterGlobal($event.target.value, 'contains')"
					style="width: auto;"
				  />
				</div>
			  </ng-template>
				<ng-template pTemplate="header">
				<tr>
					<!-- <th>Pesquisa</th>
					<th>Plataforma</th>				 -->
					<th pSortableColumn="tituloAtendimento" style="width:40%">Tipo Atendimento<p-sortIcon></p-sortIcon></th>
					<th pSortableColumn="numeroAtendimento" style="width:15%">Número<p-sortIcon></p-sortIcon></th>
					<th pSortableColumn="dataAtendimento" style="width:10%">Data<p-sortIcon></p-sortIcon></th>
					<th style="width:10%">Hora</th>
					<th style="width:15%">Canal de Entrada</th>
					<th style="width:10%">Avaliar</th>
				</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
				<!-- <div *ngFor="let solicitacao of listaSolicitacoes | sortBy: 'asc':'id'"> -->
					<tr class="centralizar">
					<!-- <td> -->
						<!-- <span class="ui-column-title">Pesquisa</span> -->
						<!-- {{ item.pesquisaSatisfacao.nome }}
					</td>
					<td> -->
						<!-- <span class="ui-column-title">Plataforma</span> -->
						<!-- {{ item.plataforma.nome | uppercase }}
					</td> -->
					<td>
						<!-- <span class="ui-column-title">Título Atendimento</span> -->
						{{ item.tituloAtendimento }}
					</td>
					<td>
						<!-- <span class="ui-column-title">Número Atendimento</span> -->
						{{ item.numeroAtendimento }}
					</td>
					<td>
						<!-- <span class="ui-column-title">Data Atendimento</span> -->
						{{ item.dataAtendimento | date: 'dd/MM/yyyy'}}
					</td>
					<td>
						<!-- <span class="ui-column-title">Hora Atendimento</span> -->
						{{ item.horaAtendimento | date: 'HH:mm' }}
					</td>
					<td>
						<!-- <span class="ui-column-title">Canal Atendimento</span> -->
						{{ item.canalAtendimento }}
					</td>
					<td>
						<!-- <button
							pButton
							type="button"
							label="Responder"
							class="ui-button-raised botao"
							(click)="responderPesquisa(item.id)"
						></button> -->
						<!-- <a (click)="abrirFormularioResposta($event, item.id)">
							<span>Responder</span>
						</a> -->
						<div class="div-botao">
							<button
							  pButton
							  type="button"
							  label="Avaliar"
							  class="ui-button-raised botao"
							  (click)="abrirFormularioResposta($event, item.id, item.tituloAtendimento, item.numeroAtendimento)"
							></button>
						  </div>
					</td>
				</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage" let-columns>
					<tr>
					  <td colspan="6" class="nenhumItem">
						✅ Todas as experiências foram avaliadas
					  </td>
					</tr>
				</ng-template>

			</p-table>
			</div>
			<div style="padding-top: 30px;">
				<a href="#" (click)="fechar($event)">← Voltar para o Portal do Aluno</a>
			</div>
		</div>
	</div>
</div>
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="square-jelly-box"
  [fullScreen]="true"
  ><p style="color: white;">Aguarde...</p>
</ngx-spinner>

<style>
	/*body .ui-table */
	tr:nth-child(even) {
    	background-color: rgb(240, 240, 240);
	}

	td.nenhumItem
	{
		text-align: center !important;
		padding-top: 60px !important;
		padding-bottom: 30px !important;
	}

	
</style>
